const APIS = {
  STAFF: "/logisticservice/api/staff/",
  USER: "/usermanagementservice/api/user/",
  USER_PROFILE: "/logisticservice/api/user-profile/",
  PRODUCT_TYPE: "logisticservice/api/product-type/",
  CLIENT_TYPE: "/logisticservice/api/client-type/",
  DELIVERY_CHARGE: "/logisticservice/api/delivery-charge/",
  CARGO_DELIVERY_CHARGE: "/logisticservice/api/delivery-charge/cargo/",
  BRANCH_CHARGE: "/logisticservice/api/branch-charge/",
  CARGO_BRANCH_CHARGE: "/logisticservice/api/branch-charge/cargo/",
  DELIVERY_CHARGE_TEMPLATE: "/logisticservice/api/delivery-charge-template/",
  STATUS: "/logisticservice/api/status/",
  BRANCH: "/logisticservice/api/branch/",
  LOCATION: "/logisticservice/api/location/",
  SERVICE_TYPE: "/logisticservice/api/service-type/",
  MERCHANT: "/logisticservice/api/merchant/",
};

export default APIS;
